'use client';

import { useEffect } from 'react';

export function TrackingListener() {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const el = (e.target as HTMLElement).closest('[data-track]');
      if (!el || !window.dataLayer) return;
      window.dataLayer.push({
        event: el.getAttribute('data-track-event') || 'button_click',
        button_name: el.getAttribute('data-track') || '',
        button_category: el.getAttribute('data-track-category') || 'Button Click',
      });
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);
  return null;
}
